import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { imageError } from '../utils/imageError';

const AccountIcon = ({ className }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" className={className}>
        <path 
            d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" 
        />
    </svg>
);

const ImageContainer = styled<any, any>('div')`
    ${propStyles};
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
`;

ImageContainer.defaultProps = {
    display: "block",
    height: ["80px", "120px"],
    width: ["80px", "120px"],
    marginY: ["sm", "0"],
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: "gray300",
    borderRadius: "120px",
    bgColor: "gray100"
};

const PlaceholderImage = styled<any, any>(AccountIcon)`
    ${propStyles};
    fill: currentColor;
    position: absolute;
    top: 0;
    left: -10%;
`;

PlaceholderImage.defaultProps = {
    display: "block",
    height: "120%",
    width: "120%",
    color: "gray300"
};

const Image = styled<any, any>('img')`
    ${propStyles};
    position: relative;
    z-index: 1;
    overflow: hidden;
    text-indent: -100em; /* hides alt text */
`;

Image.defaultProps = {
    display: "block",
    width: "100%"
};

interface FundManagerImage {
    theme?: any;
    dataStore?: any;
    name: string;
    code: string;
}

const FundManagerImage: React.SFC<FundManagerImage> = ({ theme, dataStore, name, code }) => (
    <ImageContainer
        {...theme.FundManagerImage}
    >
        <Image
            src={`${dataStore.baseUrl}/fund/fundmanagerpicture?code=${code}&token=${dataStore.token}`}
            alt={name}
            onError={e => imageError(e.target)}
        />
        <PlaceholderImage
            {...theme.FundManagerPlaceholderImage}
        />
    </ImageContainer>
);

export default inject('dataStore')(observer(withTheme(FundManagerImage)));


// WEBPACK FOOTER //
// ./src/Components/FundManagerImage.tsx